Ext.define('WindowProjectMobile', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.projekt.capitalise(),
    width: 700,
    height: 785,
    closable: false,
    collapsible: false,
    modal: true,
    scrollable: true,
    resizable: false,
    layout: 'fit',
    mobile: false,
    initComponent: function (config) {
        this.cid = Ext.id();
        let formpanel = {
            id: this.cid + "formpanel",
            title: Lang.ogolne.capitalise(),
            xtype: 'form',
            frame: true,
            border: false,
            scrollable: true,
            autoWidth: true,
            autoHeight: true,
            height: 535,
            labelWidth: 80,
            bodyStyle: 'padding:10px 10px 10px 10px',
            defaults: {
                anchor: "0",
                labelWidth: 80
            },
            fileUpload: true,
            items: [{
                anchor: "0",
                layout: 'column',
                frame: false,
                border: false,
                items: [{
                    columnWidth: 1,
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    labelWidth: 200,
                    defaults: {
                        anchor: "0",
                        labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left',
                        labelWidth: 140
                    },
                    items: [{
                        id: this.cid + "nazwa",
                        name: "nazwa",
                        xtype: 'textfieldexd',
                        regex: new RegExp(Const.PROJECTNAMEREGEX),
                        invalidText: Lang.dane_niepoprawne,
                        fieldLabel: Lang.nazwa,
                        allowBlank: false,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "czasotwarcia",
                        name: "czasotwarcia",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.czas_otwarcia,
                        editable: false,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "czaszamkniecia",
                        name: "czaszamkniecia",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.czas_zamkniecia,
                        editable: false,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "operator",
                        name: "operator",
                        fieldLabel: Lang.operator,
                        allowBlank: false,
                        xtype: "comboexd",
                        minChars: 1,
                        editable: true,
                        store: Ext.create('Ext.data.Store', {
                            fields: ['id', 'imie', 'nazwisko', {
                                name: 'nazwa',
                                convert: function(value, record) {
                                    return record.get('imie') + ' ' + record.get('nazwisko');
                                }
                            }],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/operators/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                reader: new Ext.data.JsonReader({
                                    id: "id",
                                    rootProperty: ''
                                }, [{
                                    name: 'imie',
                                    mapping: 'imie'
                                }, {
                                    name: 'nazwisko',
                                    mapping: 'nazwisko'
                                }])
                            },
                            autoLoad: false
                        }),
                        displayField: 'nazwa',
                        valueField: 'id',
                        forceSelection: true,
                        emptyText: '...'
                    }]
                }]
            }]
        };
        let zbpanel = {
            id: this.cid + "formpanel2",
            title: Lang.zbiorniki.capitalise(),
            xtype: 'form',
            frame: true,
            border: false,
            scrollable: true,
            autoWidth: true,
            autoHeight: true,
            height: 535,
            labelWidth: 80,
            bodyStyle: 'padding:10px 10px 10px 10px',
            defaults: {
                anchor: "0",
                labelWidth: 80
            },
            items: [{
                xtype: 'button',
                text: Lang.edytuj,
                disabled: false,
                style: 'margin: 5px; border: 0.5px #d9d9d9 solid',
                listeners: {
                    scope: this,
                    click: function () {
                        var zbGrid = Ext.getCmp(this.cid + "zbgrid");
                        zbGrid.setDisabled(!zbGrid.disabled);
                    }
                }
            }, {
                xtype: 'grid',
                anchor: '0',
                scrollable: true,
                disabled: true,
                id: this.cid + "zbgrid",
                tbar: [],
                store: Ext.create('Ext.data.Store', {
                    autoLoad: false,
                    model: 'NotificationType',
                    filters: [{
                        property: "disabled",
                        value: false
                    }, {
                        property: "hidden",
                        value: false
                    }],
                    proxy: {
                        type: 'memory',
                        reader: {
                            type: 'array'
                        }
                    }
                }),
                columns: [{
                    header: Lang.zbiornik,
                    flex: 3,
                    sortable: 3,
                    dataIndex: "name",
                    editable: false,
                    cellWrap: true
                }, {
                    header: Lang.active,
                    xtype: 'checkcolumn',
                    dataIndex: 'value',
                    flex: 1,
                    disabled: false,
                    overCls: 'x6-grid-checkcolumn-over',
                    listeners: {
                        scope: this,
                        checkchange: function () {
                            var store = Ext.getCmp(this.cid + "zbgrid").getStore();
                            store.commitChanges();
                        }
                    }
                }]
            }]
        }
        this.items = [{
            xtype: 'tabpanel',
            autoWidth: true,
            autoHeight: true,
            border: false,
            deferredRender: false,
            activeTab: 0,
            items: [formpanel, zbpanel, {
                id: this.cid + "formpanel4",
                title: Lang.raport,
                xtype: 'form',
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                height: 535,
                labelWidth: 80,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                items: [{
                    region: "north",
                    xtype: 'toolbar',
                    items: [{
                        xtype: 'button',
                        iconAlign: 'left',
                        iconCls: "iconPDF",
                        style: 'margin: 5px; border: 0.5px #d9d9d9 solid',
                        text: Lang.pdf.capitalise(),
                        scope: this,
                        handler: this.getDownloadLsPdf
                    }]
                }, {
                    xtype: 'panel',
                    scrollable: true,
                    items: [{
                        id: this.cid + "raport",
                        xtype: 'box',
                        border: true,
                        frame: true,
                        width: '100%',
                        cls: 'project-panel-raport',
                        height: '100%',
                        html: ''
                    }]
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex("access.manage.projects")) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        performAjaxLPromise('rest/zbiorniki/getList', {
            unassignedToProject: Const.ENABLEPROJECTS,
            alreadyAssignedProjectId: this.obiektid
        }).then(data => {
            let listFnData0 = data;
            performAjaxLPromise("rest/projects/getObjectForEdit", {
                id: this.obiektid
            }).then(data => {
                this.obiekt = data;
                this.show();
                this.center();
                this.setKeyMap({
                    'ESC': {
                        scope: this,
                        handler: this.closeOp
                    }
                });
                var operatorStore = Ext.getCmp(this.cid + "operator").getStore();
                operatorStore.load();
                Ext.getCmp(this.cid + "nazwa").setValue(null);
                Ext.getCmp(this.cid + "nazwa").clearInvalid();
                Ext.getCmp(this.cid + "czasotwarcia").setValue(null);
                Ext.getCmp(this.cid + "czasotwarcia").clearInvalid();
                Ext.getCmp(this.cid + "czaszamkniecia").setValue(null);
                Ext.getCmp(this.cid + "czaszamkniecia").clearInvalid();
                Ext.getCmp(this.cid + "operator").setValue(null);
                var zbStore = Ext.getCmp(this.cid + "zbgrid").getStore();
                let zbdata= []
                if (listFnData0) {
                    listFnData0.forEach(function(zbiornik) {
                        zbdata.push({
                            id: zbiornik.id,
                            name: zbiornik.nazwa,
                            key: zbiornik.id,
                            disabled: false,
                            hidden: false,
                        })
                    }, this);
                }
                zbStore.loadData(zbdata)
                if (this.obiekt) {
                    Ext.getCmp(this.cid + "nazwa").setValue(this.obiekt.nazwa);
                    Ext.getCmp(this.cid + "czasotwarcia").setValue(this.obiekt.czasotwarcia);
                    Ext.getCmp(this.cid + "czaszamkniecia").setValue(this.obiekt.czaszamkniecia);
                    Ext.getCmp(this.cid + "operator").setValue(this.obiekt.idoperator);
                    Ext.getCmp(this.cid + "operator").valueNotFoundText = this.obiekt.operator;
                    Ext.getCmp(this.cid + "raport").update(this.obiekt.raport);
                    for (var i = 0; i < this.obiekt.zbiorniki.length; i++) {
                        let checkedZb = this.obiekt.zbiorniki[i];
                        zbStore.getById(checkedZb).set("value", true);
                    }
                    zbStore.commitChanges();
                } else {
                    Ext.getCmp(this.cid + "operator").setValue(AppOPERATOR.id);
                    Ext.getCmp(this.cid + "formpanel4").setDisabled(true)
                }
            }).catch(err => {
                Ext.MessageBox.alert(Lang.error, err);
            });
        }).catch(err => {
            Ext.MessageBox.alert(Lang.error, err);
        });

    },
    saveOp: function () {
        var canWrite = false;
        if (Ext.getCmp(this.cid + "nazwa").isValid()) {
            canWrite = true;
        }
        if (canWrite) {
            let zbiorniki = this.getEnabledZbiorniks();
            let operator = Ext.getCmp(this.cid + "operator").getValue2NL();
            sendAjaxDataJsonRpcL("rest/projects/saveObject", {
                id: this.obiektid,
                nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
                zbiorniki: zbiorniki,
                operator: operator
            }, this, function (data) {
                if (data.status) {
                    data = data.data;
                    this.obiektid = data.id;
                    this.close();
                } else {
                    Ext.MessageBox.alert(Lang.error, data.error);
                }
                if (this.callbackF)
                    this.callbackF();
            });
        } else {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    getEnabledZbiorniks: function () {
        var store = Ext.getCmp(this.cid + "zbgrid").getStore();
        var test = store.query("value", true);
        return test.collect("key", "data");
    },
    getDownloadLsPdf: function () {
        postFormAsync("rest/projects/downloadPdfRaport", {
            id: this.obiektid
        }, null);
    },
    closeOp: function () {
        this.close();
    }
});
